var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-293 -20.025)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_524",
    "data-name": "Rect\\xE1ngulo 524",
    width: 24,
    height: 23,
    transform: "translate(293 20.025)",
    fill: "rgba(255,255,255,0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "delete_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M11.223,28.975A1.907,1.907,0,0,1,9.308,27.06V8.872H8V6.957h6V6h8.424v.957h6V8.872H27.114V27.06A1.963,1.963,0,0,1,25.2,28.975ZM25.2,8.872H11.223V27.06H25.2ZM14.605,24.316H16.52V11.584H14.605Zm5.3,0h1.915V11.584H19.9ZM11.223,8.872v0Z",
    transform: "translate(286.789 14.025)",
    fill: "#909090"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a329dbd2c5f57fbc9d7f8071b9bd0b52.svg";
export { ForwardRef as ReactComponent };